module.exports = __webpack_public_path__ + "static/media/enter-icon.afdbf948.png";